export enum CardOrientation {
  VERTICAL,
  HORIZONTAL
}

export enum TagColor {
  RED,
  GRAY
}
